<template>
  <div id="vp-status" :style="elementStyles">
    <div :class="['vp-status__output', state]" v-cloak>
      <slot>
        <span>{{text && text.toLowerCase() || state}}</span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VpStatus',
  props: {
    text: { type: String, default: '' },
    styles: { type: Object, default: () => ({}) },
    status: { type: [String, Boolean], default: 'unknown' },
  },
  computed: {
    state() {
      const status = typeof this.status === 'string' ? this.status.toLowerCase() : this.status;
      switch (status) {
        case true:
        case 'online':
        case 'enrolled':
        case 'connected':
          return 'online';
        case false:
        case 'offline':
        case 'disconnected':
          return 'offline';
        case 'pending':
          return 'pending';
        default:
          return 'unknown';
      }
    },
    elementStyles() {
      const styles = {
        '--status-font-size': this.styles.fontSize || '1rem',
        '--status-padding': this.styles.padding || '0.5rem',
        '--status-height': this.styles.height || '30px',
        '--status-transform': this.styles.textTransform || 'capitalize',
      };
      return styles;
    },
  },
};
</script>

<style lang="scss">
.vp-status {
  &__output {
    display: flex;
    align-items: center;
    align-self: flex-end;
    justify-content: center;

    height: var(--status-height);
    padding: var(--status-padding);
    font-size: var(--status-font-size);
    border-radius: 4px;
    font-weight: 400;
    line-height: 24px;
    & > * {
      line-height: 100%;
      text-transform: var(--status-transform);
    }
    &.online {
      border: 1px solid #5BBFBD;
      background: #E5F9F8;
      color: #004E4C;
    }
    &.offline {
      border: 1px solid #ce3c31;
      background-color: #fbf4f3;
      color: #4a1814;
    }
    &.pending {
      border: 1px solid #F58220;
      background-color: #FDF3EB;
      color: #66340A;
    }
    &.unknown {
      border: 1px solid #AFAFAF;
      background-color: #F5F5F5;
      color: #4F4F4F;
    }
  }
}
</style>
